<template>
  <VDialog
    v-if="dialogModel"
    v-model="dialogModel"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    :hide-overlay="$vuetify.breakpoint.smAndDown"
    max-width="600"
    class="dialog-modal"
  >
    <VCard>
      <DialogHeader
        :title="title"
        text-class="black--text"
        @close="dialogController.closeDialog()"
      />
      <VCardText class="pa-5">
        <div class="black--text">
          <slot name="text" />
        </div>
        <slot />
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
import DialogHeader from '@/components/DialogHeader';
import useDialog from '@/compositions/useDialog';
import { toRefs } from '@vue/composition-api';

export default {
  name: 'VacancyCandidatesDialog',
  components: { DialogHeader },
  props: {
    title: {
      type: String,
      required: true,
    },
    value: Boolean,
  },
  setup(props, { emit }) {
    const { value } = toRefs(props);
    const { dialogModel, dialogController } = useDialog({ emit, value });

    return {
      dialogModel,
      dialogController,
    };
  },
};
</script>
